module.exports = __webpack_public_path__ + "img/circle2.2e431785.png";